// BCM-898 · Goods Receipt Dashboard — filter bar (slide 4). [Uday]
// Renders ONLY: CMO multi-select (reused), a PO/Batch-Number search, the Search
// button, the Last-synced timestamp and Refresh. Deliberately omits MFG Plant,
// Select Product, Filter By Batch Start Date, Quick Summary Tiles and View by.
// No fetch on mount — the table appears only after a CMO is selected or a search run.
// The Last-synced/Refresh are shown at ALL times (doc rev V1) and Refresh is the
// completion step of the sync contract (V4).
import React from "react";
import { Grid, Typography, Box, CircularProgress } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import CMOFilterMultiSelect from "../../sasl/batchesDetails/batchFilter/CMOFilterMultiSelect";
import Search from "../../sasl/batchesDetails/batchFilter/Search";
import { useGRStyles } from "../goodsReceiptStyles";
import { lastSyncedLabel } from "../utils/formatters";

const FilterBar = ({
  selectedCMOList,
  filteredCMOList,
  onSelectCMO,
  tempSearch,
  onSearchChange,
  onClearSearch,
  onSubmitSearch,
  lastSynced,
  onRefresh,
  loading,
}) => {
  const classes = useGRStyles();
  return (
    <Grid container spacing={2} alignItems="flex-end" style={{ marginBottom: "0.5rem" }}>
      <Grid item xs={12} sm={4} md={3}>
        <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 4 }}>
          CMO:
        </Typography>
        <CMOFilterMultiSelect
          handleSelectCMO={onSelectCMO}
          selectedCMOList={selectedCMOList}
          filteredCMOList={filteredCMOList}
          emptyLabel="Select from list"
        />
      </Grid>

      <Grid item xs={12} sm={5} md={5}>
        <Search
          searchQuery={tempSearch}
          handleSearchQuery={onSearchChange}
          handleClearSearch={onClearSearch}
          submitSearch={onSubmitSearch}
          placeholder={"Search using PO Number, Batch Number"}
        />
      </Grid>

      <Grid item xs={12} sm={3} md={4}>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {/* A CMO selection / search is in flight — say so instead of leaving the
              filter bar looking idle while the table below reloads. */}
          {loading && (
            <Box display="flex" alignItems="center" style={{ paddingRight: 10 }}>
              <CircularProgress size={13} />
              <Typography variant="caption" style={{ color: "#6B7280", marginLeft: 6 }}>
                Loading…
              </Typography>
            </Box>
          )}
          <Typography variant="caption" className={classes.lastSynced}>
            {lastSyncedLabel(lastSynced)}
          </Typography>
          <Typography
            variant="caption"
            color="primary"
            className={classes.refresh}
            onClick={onRefresh}
          >
            Refresh
            <RefreshIcon color="primary" style={{ fontSize: 15 }} />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterBar;
